import { classNamePrefix as prefixCt } from "@/utils/common";
import { renderLatex } from "../utils";
import "../index.less";

export function getContent(node) {
  let content = "";
  if (node.dataset.content !== undefined) {
    content = node.dataset.content;
  } else {
    const $code = node.querySelector("code");
    if ($code) {
      content = $code.textContent;
    }
  }
  return content;
}

export default class latexRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("latex")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    const content = getContent(node);
    node.innerHTML = "";
    renderLatex(content, node);
  };
}
